import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { UnlockButtons, LEVEL_TEXT } from './LockedModule';
import { track } from '../lib/track';

/* Zárt lecke közvetlen linkje (Plusz 2. kör, D.3): ugyanaz a zárt nézet, mint a
   kurzusoldal zárt modulja, nem hibaoldal. Az adat a lesson_meta RPC-ből jön:
   cím, modul, leckeszám, szint; tartalom (videó, leírás) nincs benne. */
export default function LockedLesson({ meta, access, session, isMobile }) {
  const navigate = useNavigate();
  const level = meta.required_level;

  useEffect(() => {
    track(session, 'module_locked_view', { modul: meta.module_title, szint: level, hely: 'lecke' });
  }, [meta.lesson_id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{ minHeight: '100vh', background: '#0f1117', fontFamily: "'Inter', system-ui, sans-serif" }}>
      <Navbar access={access} />
      <main style={{ maxWidth: 720, margin: '0 auto', padding: isMobile ? '24px 16px' : '48px 24px' }}>
        <button type="button" onClick={() => navigate(`/tanfolyam/${meta.course_slug}`)}
          style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', fontSize: 13, cursor: 'pointer', padding: 0, marginBottom: 18, fontFamily: 'inherit' }}>
          ← {meta.course_title}
        </button>
        <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 16, padding: isMobile ? 20 : 28, display: 'grid', gap: 14 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: 'rgba(255,255,255,0.45)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
            🔒 {meta.module_order}. {meta.module_title}
          </div>
          <h1 style={{ color: '#fff', fontSize: isMobile ? 22 : 26, fontWeight: 700, margin: 0, lineHeight: 1.3 }}>{meta.title}</h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 14, lineHeight: 1.65, margin: 0 }}>
            A lecke modulja: „{meta.module_title}”, {meta.module_lessons}{' '}lecke · {LEVEL_TEXT[level]}.
            {meta.duration_minutes ? ` A lecke hossza ${meta.duration_minutes} perc.` : ''}
          </p>
          <UnlockButtons level={level} session={session} />
        </div>
      </main>
    </div>
  );
}
